import { PromotionCardData } from '../interfaces/promotion-cards.interface';

export const PROMOTION_CARDS: PromotionCardData[] = [
  {
    id: 'media-channel',
    title: '미디어매체',
    subtitle: 'Media Channel',
    imageUrl: '/event/media-channel.png',
    mainPoints: [
      '지역방송 TV Spot 광고',
      '기자간담회를 통한 지역 일간지 특집 기사 유도',
    ],
    additionalInfo: [
      '• 지역별 방송국 60-70분 <span class="text-primary-500">특별방송</span>(연예인 부스 탐방)',
      '• 후원 방송사 TV, Radio를 통한 광고 홍보, 각 채널의 문화 프로그램에 행사의 <span class="text-primary-500">적극적인 노출</span>',
    ],
  },
  {
    id: 'online-promotion',
    title: '온라인 홍보',
    subtitle: 'Online Promotion',
    imageUrl: '/event/online-promotion.png',
    mainPoints: [
      '공식 홈페이지 및 온라인 커뮤니티 활성화',
      '후원/협찬 기관 홈페이지 팝업창 및 배너홍보',
      '티켓몬스터, 쿠팡, 위메프 등 소셜 커머스 제휴 및 온라인 바이럴 마케팅 전개',
    ],
    additionalInfo: [
      '• 온라인 프로모션 전개 - 방문고객을 위한 <span class="text-primary-500">무료입장권 이벤트 전개</span>',
      '• 자치단체, 창업관련단체, 포털사이트, 각 지역 대학, 창업 및 위업관련사이트 등 <span class="text-primary-500">Web Promotion 강화</span>',
    ],
  },
  {
    id: 'promotion-materials',
    title: '선전 홍보물',
    subtitle: 'Promotion Materials',
    imageUrl: '/event/promotion-materials.png',
    mainPoints: [
      '홍보물 및 현수막 제작 (포스터, 팜플렛 등)',
      '지역별 중요 인구 밀집지역 – 플래카드 및 가로등 배너 게첨',
      '지역 소재 대학 – 플래카드 및 홍보물 부착',
    ],
    additionalInfo: [
      '• 전시장 입구 – <span class="text-primary-500">대형 현수막 부착</span>',
      '• 단계별 광고 전략 수립 – 광고매체 및 방법 (대외, 일간지, 시사지, 창업신문 등) <span class="text-primary-500">언론보도</span>',
    ],
  },
  {
    id: 'audience-mobilization',
    title: '현장국 홍보',
    subtitle: 'Audience Mobilization',
    imageUrl: '/event/audience-mobilization.png',
    mainPoints: [
      '1, 2, 3회 박람회 참관객 DB 초청장 발송',
      '지역 대학 분부 관계처 구축을 통한 대상학생 참관 유도',
      '지역 기관, 기업 및 관련단체 초청장 5만부 발송',
    ],
    additionalInfo: [
      '• 관련 단체/협회 대상 및 대학에 제휴 마케팅 제안 전달 사전 <span class="text-primary-500">행사 기대감 증폭</span>',
    ],
  },
];
